module.exports = __webpack_public_path__ + "static/img/bg_circle.32456b73.png";